import {
    ADD_SLIDE_TO_SPLIT_SYNC_VIEW, CLEAR_ALL_SLIDES_FROM_SPLIT_SYNC_VIEW, REPLACE_SLIDES_IN_SPLIT_SYNC_VIEW
} from "../redux_constants/splitSyncSlides.constant";

export const addSlideToSplitSyncView = (slide) => ({
    type: ADD_SLIDE_TO_SPLIT_SYNC_VIEW,
    slide: slide
});

export const clearAllSlidesFromSplitSyncView = () => ({
    type: CLEAR_ALL_SLIDES_FROM_SPLIT_SYNC_VIEW
})

export const replaceSlidesInSplitSyncView = (slides) => ({
    type: REPLACE_SLIDES_IN_SPLIT_SYNC_VIEW,
    slides: slides
})